export default __webpack_public_path__ + "static/media/star_with_line.48e15872.svg";